// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2JDYJ","header":"MergedInvoice_header__1tdVi"};